<template>
  <div v-show="show">
    <div
      class="relative z-[100]"
      aria-labelledby="slide-over-title"
      role="dialog"
      aria-modal="true"
    >
      <!-- Background backdrop, show/hide based on slide-over state. -->
      <div class="fixed inset-0"></div>

      <div class="fixed inset-0 overflow-hidden">
        <div class="absolute inset-0 overflow-hidden">
          <div
            class="pointer-events-none fixed inset-y-0 left-0 flex max-w-full pr-10 sm:pr-16"
          >
            <!--
          Slide-over panel, show/hide based on slide-over state.

          Entering: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-full"
            To: "translate-x-0"
          Leaving: "transform transition ease-in-out duration-500 sm:duration-700"
            From: "translate-x-0"
            To: "translate-x-full"
        -->
            <transition
              enter-active-class="transform transition ease-in-out duration-500 sm:duration-700"
              enter-class="-translate-x-full"
              enter-to-class="translate-x-0"
              leave-active-class="transform transition ease-in-out duration-500 sm:duration-700"
              leave-class="translate-x-0"
              leave-to-class="-translate-x-full"
            >
              <div v-show="show" class="pointer-events-auto w-screen max-w-md">
                <div
                  class="flex h-full flex-col overflow-y-hidden bg-white shadow-xl"
                >
                  <div class="px-5 py-3 bg-gray-100">
                    <div class="flex items-center justify-between">
                      <h2
                        class="text-sm font-semibold leading-6 text-gray-900"
                        id="slide-over-title"
                      >
                        {{ word?.word }}
                      </h2>
                      <div class="ml-3 flex h-7 items-center">
                        <button
                          @click="cancel"
                          type="button"
                          class="relative rounded-md bg-transparent text-gray-400 focus:ring-2 hover:text-markencode-blue focus:ring-markencode-blue"
                        >
                          <span class="absolute -inset-2.5"></span>
                          <span class="sr-only">Close panel</span>
                          <svg
                            class="h-6 w-6"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M6 18L18 6M6 6l12 12"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="mt-2 px-5 py-3">
                    <p class="text-sm text-gray-500">
                      {{ word?.definition }}
                    </p>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- definition: end -->
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },

    word: Object,
  },

  data() {
    return {
      showAlert: false,
    };
  },

  // watch: {
  //   word: function () {
  //     if (this.word) {
  //       this.$nextTick(() => {
  //         this.load();
  //       });
  //     } else {
  //       this.$nextTick(() => {
  //         this.reset();
  //       });
  //     }
  //   },
  // },

  methods: {
    cancel() {
      this.$emit('cancelled');
    },
  },
};
</script>